import getConfigEnv from '@brixel-io/brixel-components/dist/configuration/Settings';
import Common from '../actions/Common';
import Company from '../actions/Company';
import Upload from '../actions/Upload';
import User from '../actions/User';
import ApiClient from './ApiClient';
import getConfigEnvWeb from '@brixel-io/brixel-components/dist/configuration/SettingsWebpack';
function apiFactory({ baseURL }) {
    const api = new ApiClient({ baseURL });
    const apiData = { apiClient: api };
    return {
        common: new Common(apiData),
        company: new Company(apiData),
        image: new Upload(apiData),
        user: new User(apiData),
    };
}
const url = typeof window !== 'undefined' ? window.location.href : process.env.NODE_ENV || 'dev';
let env;
if (url.indexOf('dev') !== -1 || url.indexOf('localhost') !== -1 || url.indexOf('127') !== -1)
    env = 'DEV';
else if (url.indexOf('stag') !== -1)
    env = 'STAGING';
else
    env = 'PROD';
let configUrl = getConfigEnvWeb(env);
if (typeof window !== 'undefined') {
    configUrl = getConfigEnv;
}
export default apiFactory({
    baseURL: configUrl.apiRoot,
    // baseURL: 'http://localhost:46071/api/v3/',
});
